import './App.css';

function App() {
  return (
    <div className="App">
      <p>This is my profile</p>
    </div>
  );
}

export default App;
